'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Contacts = function (_Component) {
  (0, _inherits3.default)(Contacts, _Component);

  function Contacts() {
    (0, _classCallCheck3.default)(this, Contacts);
    return (0, _possibleConstructorReturn3.default)(this, (Contacts.__proto__ || (0, _getPrototypeOf2.default)(Contacts)).apply(this, arguments));
  }

  (0, _createClass3.default)(Contacts, [{
    key: 'render',
    value: function render() {
      var styles = require('./Contacts.scss');
      var photoIntro = require('./contacts-intro.jpg');

      var data = {
        intro: {
          text: 'Pokud máte otázky či přání, můžete nám napsat na <a href="mailto:info@nenudimse.cz" title="info@nenudimse.cz">e-mail</a> nebo zavolat na telefonní číslo <a href="tel:+420725085420" title="+420 725 085 420">725 085 420</a>.',
          image: {
            src: photoIntro,
            alt: 'Tým Nenudím se'
          }
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'Kontakty',
          meta: [{
            name: 'description',
            content: 'Kontakty na které se můžete obrátit.'
          }, {
            property: 'og:description',
            content: 'Kontakty na které se můžete obrátit.'
          }, {
            property: 'og:title',
            content: 'Kontakty'
          }, {
            name: 'keywords',
            content: 'kontakty, tym, nenudim se, nenudimse, sport, sport dětí, sportovní přípravka, sport pro děti, atletika, běhaní'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/kontakty' }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            'Kontakty',
            _react2.default.createElement(
              'small',
              null,
              'na kter\xE9 se m\u016F\u017Eete obr\xE1tit'
            )
          )
        ),
        _Content2.default.renderIntro(styles, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Nenud\xEDm se, z.s.'
                ),
                _react2.default.createElement('br', null),
                'Charkovsk\xE1 333/5, Vr\u0161ovice, 101 00 Praha 10',
                _react2.default.createElement('br', null),
                'I\u010C: 06978657'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Tom\xE1\u0161 Krupka'
                ),
                _react2.default.createElement('br', null),
                'P\u0159edseda spolku',
                _react2.default.createElement('br', null),
                'Telefon: ',
                _react2.default.createElement(
                  'a',
                  { href: 'tel:+420725085420', title: '+420 725 085 420' },
                  '725 085 420'
                ),
                _react2.default.createElement('br', null),
                'E-mail: ',
                _react2.default.createElement(
                  'a',
                  { href: 'mailto:tomas.krupka@nenudimse.cz', title: 'tomas.krupka@nenudimse.cz' },
                  'tomas.krupka@nenudimse.cz'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-6' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Tom\xE1\u0161 Kavka'
                ),
                _react2.default.createElement('br', null),
                'M\xEDstop\u0159edseda spolku',
                _react2.default.createElement('br', null),
                'Telefon: ',
                _react2.default.createElement(
                  'a',
                  { href: 'tel:+420725512462', title: '+420 725 512 462' },
                  '725 512 462'
                ),
                _react2.default.createElement('br', null),
                'Email: ',
                _react2.default.createElement(
                  'a',
                  { href: 'mailto:tomas.kavka@nenudimse.cz', title: 'tomas.kavka@nenudimse.cz' },
                  'tomas.kavka@nenudimse.cz'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              'Pokud byste se cht\u011Bli podrobn\u011Bji sezn\xE1mit s na\u0161\xEDm t\xFDmem pokra\u010Dujte na str\xE1nku s ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/nas-tym' },
                'na\u0161imi vizitkami'
              ),
              '.'
            )
          )
        )
      );
    }
  }]);
  return Contacts;
}(_react.Component);

exports.default = Contacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Contacts.js
// module id = 1106
// module chunks = 0